/*
 * Standard filters definitions
 */

// Standard Conversation Filters
export const stdConversationFilters = [
  { type: 'terms', title: 'Number', field: 'Number' },
  { type: 'terms', title: 'Agent', field: 'AgentName' },
  { type: 'terms', title: 'Tags', field: 'tags' },
  { type: 'range', title: 'CSat', field: 'CSat' },
  { type: 'terms', title: 'Category', field: 'context.analysis.category', tooltip: 'Category' },
  { type: 'terms', title: 'Subcategory', field: 'context.analysis.subcategory' },
  { type: 'terms', title: 'Tertiary category', field: 'context.analysis.subsubcategory' },
  { type: 'range', title: 'Duration', field: 'duration', description: 'Conversation duration in seconds' },
  //{ type: 'match', title: 'CSat Explanation', field: 'CSatExplanation' },
  { type: 'range', title: 'Sentiment', field: 'CustomerSentiment' },
  { type: 'range', title: 'Problems Severity', field: 'ProblemsSeverity' },
  { type: 'range', title: 'KPI Score', field: 'KPIScore' },
];

// Standard Bot Conversation Filters
export const stdBotConversationFilters = [
  { type: 'terms', title: 'Bot', field: 'botName' },
  { type: 'terms', title: 'Media', field: 'channelAttributes.media' },
  { type: 'terms', title: 'Tags', field: 'state.tags' },
  { type: 'range', title: 'CSat', field: 'CSat' },
  { type: 'terms', title: 'Category', field: 'analysis.category', tooltip: 'Category' },
  { type: 'terms', title: 'Subcategory', field: 'analysis.subcategory' },
  { type: 'terms', title: 'Tertiary category', field: 'analysis.subsubcategory' },
  { type: 'range', title: 'Bot Messages', field: 'stats.botMessages' },
  { type: 'boolean', title: 'Escalated', field: 'state.escalated' },
  { type: 'boolean', title: 'Escalated:Zendesk', field: 'state.zendeskEngaged' },
  { type: 'boolean', title: 'Escalated:Slack', field: 'state.slackEngaged' },
  { type: 'boolean', title: 'Escalated:Email', field: 'state.emailEngaged' },
  { type: 'terms', title: 'Agent', field: 'AgentName' },
  { type: 'range', title: 'Time To Agent', field: 'stats.timeToAgent', description: 'Time To agent in seconds: time between Escalated and Agent Joined' },
  { type: 'terms', title: 'Web Page (referrer)', field: 'clientAttributes.referrer' },
  { type: 'terms', title: 'Handoff Reason', field: 'state.handoffReason' },
  { type: 'boolean', title: 'Lead', field: 'state.isLead' },
];

// Bot Conversation Feedback Filter
export const stdBotConversationFeedbackFilter = [{ type: 'nested', hidden: true, field: 'messages.role', title: 'Feedback', path: 'messages', query: { type: 'term', field: 'messages.role', value: 'feedback' } }];
